<template>
  <v-card class="mt-2">
    <v-card-title class="subheading">
      Third-Party Authentications
    </v-card-title>
    <v-divider />
    <v-card-actions>
      <v-chip
        :color="
          themes.candidate.light[`${hasProvider('google') ? 'success' : 'secondaryAction'}Button`]
        "
      >
        <v-avatar>
          <v-btn
            slot="activator"
            :color="
              themes.candidate.light[
                `${hasProvider('google') ? 'success' : 'secondaryAction'}Button`
              ]
            "
            @click="addProvider('google')"
            small
            fab
          >
            <v-icon> {{ hasProvider('google') ? 'mdi-check' : 'mdi-plus' }} </v-icon>
          </v-btn>
        </v-avatar>
        <v-icon class="pl-2" :dark="hasProvider('google')"> mdi-google </v-icon>
        <span class="pl-3">Google</span>
      </v-chip>

      <v-chip
        :color="
          themes.candidate.light[`${hasProvider('facebook') ? 'success' : 'secondaryAction'}Button`]
        "
      >
        <v-avatar>
          <v-btn
            slot="activator"
            :color="
              themes.candidate.light[
                `${hasProvider('facebook') ? 'success' : 'secondaryAction'}Button`
              ]
            "
            @click="addProvider('facebook')"
            small
            fab
          >
            <v-icon>
              {{ hasProvider('facebook') ? 'mdi-check' : 'mdi-plus' }}
            </v-icon>
          </v-btn>
        </v-avatar>
        <v-icon class="pl-2" :dark="hasProvider('facebook')"> mdi-facebook </v-icon>
        <span class="pl-3">Facebook</span>
      </v-chip>

      <v-chip
        :color="
          themes.candidate.light[`${hasProvider('linkedin') ? 'success' : 'secondaryAction'}Button`]
        "
      >
        <v-avatar>
          <v-btn
            slot="activator"
            :color="
              themes.candidate.light[
                `${hasProvider('linkedin') ? 'success' : 'secondaryAction'}Button`
              ]
            "
            @click="addProvider('linkedin')"
            small
            fab
          >
            <v-icon>
              {{ hasProvider('linkedin') ? 'mdi-check' : 'mdi-plus' }}
            </v-icon>
          </v-btn>
        </v-avatar>
        <v-icon class="pl-2" :dark="hasProvider('linkedin')"> mdi-linkedin </v-icon>
        <span class="pl-3">LinkedIn</span>
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  computed: mapGetters({
    providers: 'auth/providers',
  }),
  methods: {
    hasProvider(provider) {
      // return true
      return this.providers.indexOf(provider) >= 0
    },

    addProvider(provider) {
      if (!this.hasProvider(provider)) this.$store.dispatch('auth/provider', { provider })
    },
  },
}
</script>
